import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { StampCollectedProps } from '../../interfaces/components';
import { PassportCircle } from '../../Icons/PassportCircle';
import { useTranslation } from 'react-i18next';

const StampCollected = ({ collected, fill, stroke }: StampCollectedProps) => {
  const { t } = useTranslation();

  return (
    <Box
      h={['50px', '50px', '55px']}
      borderRadius="0px"
      border={`1px solid ${stroke}`}
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap="5"
      bg="#fff"
      px="5"
    >
      <Box display="flex" gap="3px">
        <PassportCircle fill={collected >= 1 ? fill : '#fff'} stroke={stroke} boxSize={[3]} />
        <PassportCircle fill={collected >= 2 ? fill : '#fff'} stroke={stroke} boxSize={[3]} />
        <PassportCircle fill={collected >= 3 ? fill : '#fff'} stroke={stroke} boxSize={[3]} />
      </Box>
      <Text fontFamily="JosefinSans" fontSize={['12px', '12px', '14px', '16px']} color={stroke} textAlign="center">
        {collected === 1 ? t('passport-badge-collected') : t('passport-badges-collected')}
      </Text>
    </Box>
  );
};

export default StampCollected;
